// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page wrapper */
.services-page {
  min-height: 100vh;
  width: 100%;
}

/* ✅ Hero section background similar to Vision & Mission */
.services-hero {
  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 52px 16px 70px;

  background: linear-gradient(
    180deg,
    rgba(29, 67, 154, 0.08) 0%,
    rgba(196, 0, 0, 0.06) 40%,
    rgba(246, 247, 251, 1) 100%
  );
}

/* Main content wrapper */
.services-wrapper {
  width: 100%;
  max-width: 1100px;
}

/* ✅ New hero header (Vision & Mission style) */
.services-hero-header {
  text-align: center;
  padding: 18px 10px 34px;
}

.services-kicker {
  margin: 0 0 10px;
  color: #000;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  font-size: 12px;
}

.services-hero-title {
  margin: 0;
  font-size: 44px;
  font-weight: 900;
  line-height: 1.1;
}

.services-title-red {
  color: #c40000;
}

.services-title-blue {
  color: #1d439a;
}

.services-title-dark {
  color: #1d439a;
}

.services-hero-underline {
  width: 150px;
  height: 6px;
  margin: 16px auto 14px;
  border-radius: 999px;
  background: linear-gradient(90deg, #c40000, #1d439a);
}

.services-hero-subtitle {
  margin: 0 auto;
  max-width: 850px;
  color: #334155;
  font-size: 16px;
  line-height: 1.7;
  font-weight: 500;
}

/* Grid */
.services-grid {
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin-top: 10px;
}

/* Flip Card */
.flip-card {
  width: 100%;
  perspective: 1200px;
}

/* Use GRID stacking so card height becomes tallest face */
.flip-inner {
  display: grid;
  width: 100%;
  transform-style: preserve-3d;
  transition: transform 0.65s cubic-bezier(0.2, 0.8, 0.2, 1);
}

/* Stack both faces in same grid cell */
.flip-face {
  grid-area: 1 / 1;
  border-radius: 12px;
  border-left: 8px solid #1d439a;
  background: #ffffff;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.1);
  backface-visibility: hidden;
}

/* Flip behavior */
.flip-inner.is-flipped {
  transform: rotateY(180deg);
}

/* FRONT */
.flip-front {
  border: none;
  cursor: pointer;
  text-align: left;
  padding: 26px 28px;
  display: flex;
  align-items: center;
  background: #ffffff;
}

.flip-front:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.14);
}

.flip-title {
  font-size: 26px;
  font-weight: 800;
  margin: 0 0 8px 0;
  color: #1d439a;
}

.flip-hint {
  margin: 0;
  font-size: 15px;
  color: #444;
  font-weight: 600;
}

.flip-arrow {
  color: #c40000;
  font-weight: 900;
  margin-left: 4px;
}

/* BACK */
.flip-back {
  transform: rotateY(180deg);
  padding: 22px 28px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #ffffff;
}

.flip-back-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 10px;
}

.back-title {
  margin: 0;
}

.flip-close {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  color: #333;
  padding: 6px 8px;
  border-radius: 8px;
}

.flip-close:hover {
  background: rgba(0, 0, 0, 0.06);
}

.flip-body {
  color: #222;
  line-height: 1.7;
  font-size: 16px;
}

.flip-body p {
  margin: 0 0 10px 0;
}

.flip-body ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
}

.flip-body li {
  margin-bottom: 8px;
}

.strong-text {
  font-weight: 800;
}

.flip-back-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.flip-back-btn {
  background: #c40000;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 800;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.flip-back-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 20px rgba(196, 0, 0, 0.22);
}

/* Responsive */
@media (max-width: 768px) {
  .services-hero-title {
    font-size: 32px;
  }

  .flip-title {
    font-size: 20px;
  }

  .flip-front {
    padding: 18px 18px;
  }

  .flip-back {
    padding: 18px 18px;
  }

  .flip-body {
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AAN/AANServices.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB;;;;;GAKC;AACH;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,0DAA0D;AAC5D;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Page wrapper */\n.services-page {\n  min-height: 100vh;\n  width: 100%;\n}\n\n/* ✅ Hero section background similar to Vision & Mission */\n.services-hero {\n  width: 100%;\n  min-height: calc(100vh - 80px);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 52px 16px 70px;\n\n  background: linear-gradient(\n    180deg,\n    rgba(29, 67, 154, 0.08) 0%,\n    rgba(196, 0, 0, 0.06) 40%,\n    rgba(246, 247, 251, 1) 100%\n  );\n}\n\n/* Main content wrapper */\n.services-wrapper {\n  width: 100%;\n  max-width: 1100px;\n}\n\n/* ✅ New hero header (Vision & Mission style) */\n.services-hero-header {\n  text-align: center;\n  padding: 18px 10px 34px;\n}\n\n.services-kicker {\n  margin: 0 0 10px;\n  color: #000;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  font-size: 12px;\n}\n\n.services-hero-title {\n  margin: 0;\n  font-size: 44px;\n  font-weight: 900;\n  line-height: 1.1;\n}\n\n.services-title-red {\n  color: #c40000;\n}\n\n.services-title-blue {\n  color: #1d439a;\n}\n\n.services-title-dark {\n  color: #1d439a;\n}\n\n.services-hero-underline {\n  width: 150px;\n  height: 6px;\n  margin: 16px auto 14px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #c40000, #1d439a);\n}\n\n.services-hero-subtitle {\n  margin: 0 auto;\n  max-width: 850px;\n  color: #334155;\n  font-size: 16px;\n  line-height: 1.7;\n  font-weight: 500;\n}\n\n/* Grid */\n.services-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  margin-top: 10px;\n}\n\n/* Flip Card */\n.flip-card {\n  width: 100%;\n  perspective: 1200px;\n}\n\n/* Use GRID stacking so card height becomes tallest face */\n.flip-inner {\n  display: grid;\n  width: 100%;\n  transform-style: preserve-3d;\n  transition: transform 0.65s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n/* Stack both faces in same grid cell */\n.flip-face {\n  grid-area: 1 / 1;\n  border-radius: 12px;\n  border-left: 8px solid #1d439a;\n  background: #ffffff;\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.1);\n  backface-visibility: hidden;\n}\n\n/* Flip behavior */\n.flip-inner.is-flipped {\n  transform: rotateY(180deg);\n}\n\n/* FRONT */\n.flip-front {\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  padding: 26px 28px;\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n}\n\n.flip-front:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.14);\n}\n\n.flip-title {\n  font-size: 26px;\n  font-weight: 800;\n  margin: 0 0 8px 0;\n  color: #1d439a;\n}\n\n.flip-hint {\n  margin: 0;\n  font-size: 15px;\n  color: #444;\n  font-weight: 600;\n}\n\n.flip-arrow {\n  color: #c40000;\n  font-weight: 900;\n  margin-left: 4px;\n}\n\n/* BACK */\n.flip-back {\n  transform: rotateY(180deg);\n  padding: 22px 28px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: #ffffff;\n}\n\n.flip-back-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 10px;\n}\n\n.back-title {\n  margin: 0;\n}\n\n.flip-close {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 1;\n  color: #333;\n  padding: 6px 8px;\n  border-radius: 8px;\n}\n\n.flip-close:hover {\n  background: rgba(0, 0, 0, 0.06);\n}\n\n.flip-body {\n  color: #222;\n  line-height: 1.7;\n  font-size: 16px;\n}\n\n.flip-body p {\n  margin: 0 0 10px 0;\n}\n\n.flip-body ul {\n  margin: 8px 0 0 0;\n  padding-left: 20px;\n}\n\n.flip-body li {\n  margin-bottom: 8px;\n}\n\n.strong-text {\n  font-weight: 800;\n}\n\n.flip-back-footer {\n  margin-top: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.flip-back-btn {\n  background: #c40000;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-weight: 800;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.flip-back-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 20px rgba(196, 0, 0, 0.22);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .services-hero-title {\n    font-size: 32px;\n  }\n\n  .flip-title {\n    font-size: 20px;\n  }\n\n  .flip-front {\n    padding: 18px 18px;\n  }\n\n  .flip-back {\n    padding: 18px 18px;\n  }\n\n  .flip-body {\n    font-size: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
